module.exports = __webpack_public_path__ + "img/coin_2.78748f33.png";